/**
 * Function that returns sorted ids in an array.
 *
 * @param placementIds - array with strings starting with same characters and numbers in the end example:
 * [homePage1, homePage5, homePage12, homePage3]
 * @returns: sorted array in ascending manner example: [homePage1, homePage3, homePage5, homePage12].
 */

export const getSortedPlacementIds = (placementIds = []) => {
  const sortedPlacementIds = [...placementIds];

  return sortedPlacementIds.sort((id1, id2) => {
    const num1 = parseInt(id1.match(/\d+/)?.[0]);
    const num2 = parseInt(id2.match(/\d+/)?.[0]);

    return num1 - num2;
  });
};
